import React from "react";
import PropTypes from "prop-types";
import "./Items.css";
import { Dialog, DialogContent, Grid, Typography } from "@mui/material";
import fallbackImage from "../../../assets/images/noimage.png";

const Items = (props) => {
  const { data, openItemDialog, setOpenItemDialog } = props;

  const handleCloseItemDialog = () => {
    setOpenItemDialog(false);
  };

  const onMediaFallback = (e) => (e.target.src = fallbackImage);

  if (data === null) return null;

  return (
    <Dialog onClose={handleCloseItemDialog} open={openItemDialog}>
      <DialogContent>
        <Grid container marginBottom="20px">
          <Grid
            item
            xs={12}
            marginTop="20px"
            marginBottom="20px"
            textAlign="center"
          >
            <img
              src={data.url || fallbackImage}
              alt="product"
              height="150px"
              onError={onMediaFallback}
            />
          </Grid>
          <Grid item xs={12}>
            <Typography align="center">
              {data.item_code ? data.item_code.item_code : ""}
            </Typography>
          </Grid>
          <Grid item xs={12}>
            <Typography align="center">{data.name}</Typography>
          </Grid>
          <Grid item xs={12} marginTop="20px">
            <Typography variant="h6" align="center">
              Unit:
              {data.display_unit_price > 0
                ? ` $${data.display_unit_price}`
                : ` N/A`}
            </Typography>
          </Grid>
          <Grid item xs={12} marginBottom="20px">
            <Typography variant="h6" align="center">
              Case:
              {data.display_case_price > 0
                ? ` $${data.display_case_price} (${data.units_per_case})`
                : ` N/A`}
            </Typography>
          </Grid>
          <Grid item xs={6}>
            <Typography align="right">Item Description:</Typography>
          </Grid>
          <Grid item xs={6}>
            <Typography align="left" className="typographySpacing">
              {data.api_description ? data.api_description : ""}
            </Typography>
          </Grid>
          <Grid item xs={6}>
            <Typography align="right">UPC:</Typography>
          </Grid>
          <Grid item xs={6}>
            <Typography align="left" className="typographySpacing">
              {data.upc ? data.upc : ""}
            </Typography>
          </Grid>
        </Grid>
      </DialogContent>
    </Dialog>
  );
};

Items.propTypes = {
  openItemDialog: PropTypes.any.isRequired,
  setOpenItemDialog: PropTypes.any.isRequired,
};

export default Items;
